module.exports = __webpack_public_path__ + "img/empty-items.63694073.svg";